import { Component} from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, ToastController, ViewController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
/**
 * Generated class for the DeleteaccountPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-deleteaccount',
  templateUrl: 'deleteaccount.html',
})
export class DeleteaccountPage {

    loginId: string;
	api_key: string;
	email: string;
	version: string;
    
    texts: any = [];
	language : string;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private http: HttpService,
		public modalCtrl: ModalController,
		public alertCtrl:AlertController,
		public toastCtrl: ToastController,
        public viewCtrl: ViewController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
		public app: App
    ) {

	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "deleteaccount");
        this.language = localStorage.getItem("language");
        this.email = localStorage.getItem("email");
        this.version = localStorage.getItem("version");
        
        this._get_texts();       

	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).deleteaccount;
	}
	
	_confirm() {
		let url = "user/info/index/breakaway";
        let body = JSON.stringify({
            api: this.api_key,
            language: this.language,
            version: this.version
        });
        this.http.post(url, body).then((res: any) => {
            if(res.result === "OK"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                this._close();
                localStorage.removeItem("loginId");
                localStorage.removeItem("api_key");
                this.app.getRootNav().setRoot(LoginPage);

            } else if(res.result ==="RELOAD"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();

            } else {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
        },(err)=>{	
            //// HTTP 에러인 경우
            let alert = this.alertCtrl.create({
                message: this.texts.alertM_err,
                buttons: ['OK']
            });
            alert.present();
        
        });
	}
	
	_close() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/deleteaccount/deleteaccount.ts